"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../Methods/styles.module.scss"));
var TotalInfo_1 = __importDefault(require("../TotalInfo"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var BottomBlockWithTotalInfo = function (_a) {
    var IFrameUrl = _a.IFrameUrl, isIFrameMethod = _a.isIFrameMethod, amount = _a.amount, currency = _a.currency, footerInsideInfo = _a.footerInsideInfo, category = _a.category, SubmitButton = _a.SubmitButton, isModal = _a.isModal;
    var t = (0, next_intl_1.useTranslations)('translation');
    var showContent = (0, react_1.useMemo)(function () { return !IFrameUrl && !isIFrameMethod; }, [IFrameUrl, isIFrameMethod]);
    var showCryptoInfo = (0, react_1.useMemo)(function () { return category === 'payment-systems'; }, [category]);
    if (isIFrameMethod)
        return null;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.bottomBlockWithTotalInfoContainer, isModal && styles_module_scss_1.default.modal) },
        showContent && (react_1.default.createElement(TotalInfo_1.default, { fee: 0, totalAmount: amount, currency: currency }, footerInsideInfo && (react_1.default.createElement(react_1.default.Fragment, null,
            showCryptoInfo && (react_1.default.createElement("div", { className: styles_module_scss_1.default.info }, t('withdrawalCryptoInfo'))),
            SubmitButton)))),
        !footerInsideInfo && showContent && (react_1.default.createElement(react_1.default.Fragment, null,
            showCryptoInfo && (react_1.default.createElement("div", { className: styles_module_scss_1.default.info }, t('withdrawalCryptoInfo'))),
            SubmitButton)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.supportButtonWrapper },
            react_1.default.createElement(ui_components_1.SupportButton, { text: t('needHelpQuestion') }))));
};
exports.default = react_1.default.memo(BottomBlockWithTotalInfo);
